<template>
  <div class="home">
    <Home :msg="$i18n.t('Welcome to 08000')" />
  </div>
</template>

<script>
import Home from "@/components/Home.vue";

export default {
  metaInfo() {
    return {
      title: this.$i18n.t("SmartSLA home page")
    };
  },
  name: "home",
  components: {
    Home
  }
};
</script>

<style lang="stylus" scoped></style>
